const Section = ({ name, stretched, className, children, ...rest }) => {
    return (
        <div id={name} className={`flex flex-col ${stretched ? 'p-0 m-0' : 'p-4 m-0'} ${className}`} {...rest}>
            {children}
        </div>
    )
};

export default Section;